import { cx } from '@hrworks/design-system/functions';
import { Divider } from '@hrworks/sui-core/Divider';
import { StreamlineIcon } from '@hrworks/sui-core/StreamlineIcon';
import { SidebarContext } from '@hrworks/sui-shared/contexts';

import { S } from './Sidebar.styles';
import type { SidebarProps } from './Sidebar.types';

const SIDEBAR_CONTEXT_VALUE = {};

export const Sidebar = ({
  children,
  upperSidebarChildren,
  brandingElement,
  showUpperSidebarChildren,
  continueAsUrl,
  continueAsText,
  className,
  ...otherProps
}: SidebarProps) => (
  <S.Container className={cx(S.cls.Container, className)} {...otherProps}>
    {brandingElement}
    <S.Scroller className={S.cls.Scroller}>
      <SidebarContext value={SIDEBAR_CONTEXT_VALUE}>
        {!!upperSidebarChildren && !!showUpperSidebarChildren && (
          <S.UpperSidebarChildrenContainer className={S.cls.UpperSidebarChildrenContainer}>
            {upperSidebarChildren}
            <Divider />
          </S.UpperSidebarChildrenContainer>
        )}
        {children}
      </SidebarContext>
    </S.Scroller>
    {continueAsUrl && (
      <S.ContinueAsButtonWrapper className={S.cls.ContinueAsButtonWrapper}>
        <S.ContinueAsButton
          className={S.cls.ContinueAsButton}
          href={continueAsUrl}
          target="_blank"
          variant="subtle"
          rightIcon={<StreamlineIcon name="direction-right" />}
        >
          {continueAsText}
        </S.ContinueAsButton>
      </S.ContinueAsButtonWrapper>
    )}
  </S.Container>
);
